/**
 * @generated SignedSource<<2ebcc0b8a4859deeb46f65f3289d2264>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubmitInput = {
  answer?: string | null;
  answers?: ReadonlyArray<string> | null;
  id: string;
};
export type useSubmitPollMutation$variables = {
  input: SubmitInput;
};
export type useSubmitPollMutation$data = {
  readonly submit: {
    readonly id: string;
    readonly responseStatistics: ReadonlyArray<{
      readonly correct: boolean;
      readonly key: string;
      readonly ratio: number;
      readonly selected: boolean;
    }> | null;
  } | null;
};
export type useSubmitPollMutation = {
  response: useSubmitPollMutation$data;
  variables: useSubmitPollMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PollQuestion",
    "kind": "LinkedField",
    "name": "submit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollResponseStatistic",
        "kind": "LinkedField",
        "name": "responseStatistics",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ratio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "correct",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "selected",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitPollMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSubmitPollMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3942283c926bc80bbd87adc0816d271d",
    "id": null,
    "metadata": {},
    "name": "useSubmitPollMutation",
    "operationKind": "mutation",
    "text": "mutation useSubmitPollMutation(\n  $input: SubmitInput!\n) {\n  submit(input: $input) {\n    id\n    responseStatistics {\n      key\n      ratio\n      correct\n      selected\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "47b30b42f44c2aefeda535d19da23cf1";

export default node;
